import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Box, CircularProgress } from "@mui/material";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import Layout from "./pages/Layout";
import Login from "./pages/Login";
import LoginOTP from "./pages/LoginOTP";
import ChooseTwoFactorMethod from "./pages/ChooseTwoFactorMethod";
import SetPassword from "./pages/SetPasswordPage";
import {
  PermissionProvider,
  useFlatRoutes,
  usePermissions,
} from "./contexts/PermissionContext";
import { ExportPollingProvider } from "./contexts/ExportPollingContext";
import { COLORS, theme } from "./assets/theme";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

function AppRoutes() {
  const pageRoutes = useFlatRoutes();
  const { isLoading } = usePermissions();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
        }}
      >
        <CircularProgress size={50} thickness={5} sx={{ color: COLORS.GOLD }} />
      </Box>
    );
  }

  return (
    <Routes>
      <Route path="login" Component={Login} />
      <Route path="choose-2fa" Component={ChooseTwoFactorMethod} />
      <Route path="login-otp" Component={LoginOTP} />
      <Route path="set_password" Component={SetPassword} />
      <Route Component={Layout}>
        {pageRoutes.map((route) => (
          <Route key={route.id} path={route.link} Component={route.component} />
        ))}
        <Route
          path="*"
          element={<Navigate to={pageRoutes[0]?.link ?? "/"} replace />}
        />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="">
          <PermissionProvider>
            <ExportPollingProvider>
              <AppRoutes />
            </ExportPollingProvider>
          </PermissionProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default App;
